import { render, staticRenderFns } from "./VBrokerUnrestrictCard.vue?vue&type=template&id=cebe7ea6&scoped=true"
import script from "./VBrokerUnrestrictCard.vue?vue&type=script&lang=js"
export * from "./VBrokerUnrestrictCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebe7ea6",
  null
  
)

export default component.exports